/**
 * Converts a number to its ordinal string representation
 * @param n - The number to convert
 * @returns The ordinal string (e.g., "1st", "2nd", "3rd", "4th")
 * 
 * @example
 * ordinal(1)  // "1st"
 * ordinal(2)  // "2nd"
 * ordinal(3)  // "3rd"
 * ordinal(11) // "11th"
 * ordinal(21) // "21st"
 * ordinal(42) // "42nd"
 */
export function ordinal(n: number): string {
  const s = ["th", "st", "nd", "rd"];
  const v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
}

/**
 * Converts a number to its ordinal word representation
 * @param n - The number to convert (1-based index)
 * @returns The ordinal word (e.g., "First", "Second", "Third")
 * Falls back to ordinal number format for n > 10
 * 
 * @example
 * ordinalWord(1)  // "First"
 * ordinalWord(2)  // "Second"
 * ordinalWord(11) // "11th"
 */
export function ordinalWord(n: number): string {
  const words = [
    "First", "Second", "Third", "Fourth", "Fifth",
    "Sixth", "Seventh", "Eighth", "Ninth", "Tenth"
  ];
  
  return n <= words.length ? words[n - 1] : ordinal(n);
}

